/**
 * The edge highlight for a frozen column, ported from the Custom Rules table
 * (`ai-custom-rules-playground/custom-rules-table.tsx`) so both grids read the same.
 *
 * It is a gradient strip, not a `box-shadow`, and that is not a style choice:
 * Tailwind's preflight puts `border-collapse: collapse` on every table, and Chrome
 * drops box-shadows on the cells of a collapsed-border table. The `shadow-[...]`
 * this replaces had therefore never actually painted.
 *
 * The strip hangs just OUTSIDE the cell it belongs to (`translate-x-full`), so
 * `side` names the cell edge it sits on: `right` for a left-pinned column (the
 * shadow falls rightwards into the scrolling content), `left` for a right-pinned
 * one. A frozen cell is `position: sticky` and therefore already a positioned box,
 * so it needs no `relative` of its own to anchor this.
 */
export const StickyEdgeShadow = ({
	show,
	side = 'left'
}: {
	show: boolean
	side?: 'left' | 'right'
}) => (
	<span
		aria-hidden
		className={`pointer-events-none absolute inset-y-0 z-[1] w-2 transition-opacity duration-200 ${
			side === 'right'
				? 'right-0 translate-x-full bg-gradient-to-r from-[rgba(0,0,0,0.10)] to-[rgba(0,0,0,0)]'
				: 'left-0 -translate-x-full bg-gradient-to-l from-[rgba(0,0,0,0.10)] to-[rgba(0,0,0,0)]'
		} ${show ? 'opacity-100' : 'opacity-0'}`}
	/>
)
